import SecurityBadgeIcon from './SecurityBadgeIcon';
export default SecurityBadgeIcon;
